<template>
  <div class="stk-yourstake-icon">
    <img
      :src="src"
      alt="YourStake Icon"
    >
  </div>
</template>


<script>
export default {
  name: 'YourStakeIcon',
  computed: {
    src() {
      return this.$root.$data.STATIC_ROOT + 'images/stake.svg';
    },
  },
};
</script>

<style>
.stk-yourstake-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-self: center;
  height: 2rem;
  width: 2rem;
}
</style>
